import React from 'react';
import { DRAG_AND_DROP_ZONE } from '~/training/sequence/templates/items';
import { Item, ItemDefinition, registry, RenderProps } from '../Item';
import { DragAndDropProvider } from './DragAndDropStore';

export type DragAndDropZoneDefinition = ItemDefinition<
  typeof DRAG_AND_DROP_ZONE
>;

export class DragAndDropZone extends Item<typeof DRAG_AND_DROP_ZONE> {
  protected render({ children }: RenderProps<void>) {
    return <DragAndDropProvider>{children}</DragAndDropProvider>;
  }
}

registry[DRAG_AND_DROP_ZONE] = DragAndDropZone;
